var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '@angular/core';
import { OptionItem } from '../../../diagram/utils/option-item';
import * as _ from 'lodash';
import { ConditionType } from './condition-type';
import { ConfigureComponentBase } from '../../../../../shared/configure-component-base';
var ConditionTypeOptionService = /** @class */ (function (_super) {
    __extends(ConditionTypeOptionService, _super);
    function ConditionTypeOptionService(injector) {
        var _this = _super.call(this, injector) || this;
        _this.optionList = [
            new OptionItem(ConditionType.Bit, _this.lc('BitVariable')),
            new OptionItem(ConditionType.Word, _this.lc('WordVariable'))
        ];
        return _this;
    }
    ConditionTypeOptionService.prototype.getOptions = function () {
        return this.optionList;
    };
    ConditionTypeOptionService.prototype.getOptionNameByKey = function (key) {
        // eslint-disable-next-line eqeqeq
        var option = _.find(this.optionList, function (s) { return s.key == key; });
        return option ? option.name : '';
    };
    ConditionTypeOptionService = __decorate([
        Injectable()
    ], ConditionTypeOptionService);
    return ConditionTypeOptionService;
}(ConfigureComponentBase));
export { ConditionTypeOptionService };
